/* eslint-disable no-param-reassign */
import moment from 'moment/moment';
import { createSearchParams } from 'react-router-dom';
import { checkSearch } from '../../services/customer/ticketBookingServices';
import showErrorMessageModal from '../../components/customer/components/modals/showErrorMessageModal/showErrorMessageModal';
import treatMomentAsUTC from './treatMomentAsUtc';

export function formTicketSearchValues(values, navigate) {
  if (!values.returnDateFrom) {
    delete values.returnDateFrom;
  } else {
    values.returnDateFrom = moment(values.returnDateFrom).format('YYYY-MM-DD');
  }

  if (!moment(values?.departureDateFrom).isValid()) {
    values.departureDateFrom = moment().format('YYYY-MM-DD');
    navigate({ pathname: '/ka/search', search: `?${createSearchParams(values)}` });
  } else {
    values.departureDateFrom = treatMomentAsUTC(values.departureDateFrom).format('YYYY-MM-DD');
  }
  return values;
}

export async function validateTicketSearch({
  values, setErrors, navigate, currentLanguage, trans,
}) {
  try {
    if (
      (
        (values?.child_passengers || 0)
         + (values?.standard_passengers || 0)
         + (values?.disabled_passengers || 0)) > 9
    ) {
      showErrorMessageModal({
        errorText: trans('statement_booking_warning'),
        onOk: async () => {
          const searchValues = formTicketSearchValues(values, navigate);
          await checkSearch(searchValues);
          navigate({ pathname: `/${currentLanguage}/search`, search: `?${createSearchParams(searchValues)}` });
          setErrors(null);
        },
      });
    } else {
      const searchValues = formTicketSearchValues(values, navigate);
      await checkSearch(searchValues);
      navigate({ pathname: `/${currentLanguage}/search`, search: `?${createSearchParams(searchValues)}` });
      setErrors(null);
    }
  } catch (e) {
    setErrors(e.response?.data?.errors);
  }
}
